import { render, staticRenderFns } from "./Page030.vue?vue&type=template&id=0fd68afa&scoped=true&"
import script from "./Page030.vue?vue&type=script&lang=js&"
export * from "./Page030.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd68afa",
  null
  
)

export default component.exports